"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaCarousel = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Carousel = require("../Carousel");
var _MediaCarouselPaginationStep = require("./MediaCarouselPaginationStep");
var _MediaCarouselSlide = require("./MediaCarouselSlide");
var _constants = require("./constants");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore next -- Testable only in browser. */const updateLoadedSlides = setLoadedSlides => slider => {
  setLoadedSlides(prevLoadedSlides => prevLoadedSlides.includes(slider.track.details.rel) ? prevLoadedSlides : [...prevLoadedSlides, slider.track.details.rel]);
};
const MediaCarousel = ({
  data,
  autoplay,
  id,
  className,
  navigation,
  pagination,
  propagateDragEvent,
  showPlaceholderIfEmpty = true,
  slider,
  testId,
  width
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const filteredData = (0, _react.useMemo)(() => (0, _utils.filterEmptyData)(data), [data]);
  const [loadedSlides, setLoadedSlides] = (0, _react.useState)([0]);
  const resultSlider = (0, _react.useMemo)(() => ({
    ...slider,
    animationEnded: updateLoadedSlides(setLoadedSlides)
  }), [slider]);
  const renderPaginationStep = (0, _react.useCallback)(({
    slideIndex,
    hidden,
    isActive,
    onPaginationStepClick
  }) => {
    if (slideIndex >= filteredData.length) {
      return null;
    }
    const slide = filteredData[slideIndex];
    if (!slide) {
      return null;
    }
    const {
      src,
      type
    } = slide;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaCarouselPaginationStep.MediaCarouselPaginationStep, {
      src: src,
      type: type,
      hidden: hidden,
      isActive: isActive,
      slideIndex: slideIndex,
      onPaginationStepClick: onPaginationStepClick
    });
  }, [filteredData]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.Carousel, {
    autoplay: autoplay,
    className: className,
    id: id,
    navigation: {
      height: isMobile ? _constants.NAVIGATION_MOBILE_HEIGHT : undefined,
      ...navigation
    },
    pagination: {
      maxVisibleItems: 4,
      ...pagination
    },
    propagateDragEvent: propagateDragEvent,
    showPlaceholderIfEmpty: showPlaceholderIfEmpty,
    slider: resultSlider,
    testId: testId ?? getTestId(_constants.MEDIA_CAROUSEL),
    width: width,
    renderPaginationStep: renderPaginationStep,
    children: filteredData.map((mediaCarouselSlideData, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaCarouselSlide.MediaCarouselSlide, {
      shouldLoad: loadedSlides.includes(index),
      ...mediaCarouselSlideData
    }, mediaCarouselSlideData.src))
  });
};
exports.MediaCarousel = MediaCarousel;
//# sourceMappingURL=MediaCarousel.js.map